export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/wmd-logo-promotion-english-a260519aff87c4ef64ac07ab029cf902.svg";